// extracted by mini-css-extract-plugin
export default {"appInputDropdown":"AppInputDropdown_appInputDropdown__oh3XN"};